import { render, staticRenderFns } from "./ModalTermos.vue?vue&type=template&id=3355e21d&scoped=true&"
import script from "./ModalTermos.vue?vue&type=script&lang=js&"
export * from "./ModalTermos.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermos.vue?vue&type=style&index=0&id=3355e21d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355e21d",
  null
  
)

export default component.exports